// probably timing problem with lit: https://github.com/lit/lit/blob/7453e365000e6a289c139cf7e175a4742296333d/packages/reactive-element/src/css-tag.ts#L10
// if lit is loaded before style sheet it cannot handle CSSStyleSheets from AdornisCSS
import 'construct-style-sheets-polyfill'; // THIS HAS TO BE THE FIRST IMPORT FOR FIREFOX TO WORK CORRECTLY

import { registerTracking } from '@adornis/analytics/client/hooks/util.js';
import { logger } from '@adornis/base/logging.js';
import { BaseQLClient } from '@adornis/baseql/client/baseqlClient.js';
import { registerServerLogger } from '@adornis/baseql/utils/logger.js';
import { DesignSystem } from '@adornis/chemistry/elements/theming/design.js';
import { baseConfig } from '@adornis/config/baseConfig.js';
import { ExportDataView } from '@adornis/data-view/db/export-data-view.js';
import '@adornis/fonts/fonts.js';
import { initApp } from '@adornis/functional-lit/init-app.js';
import { currentUser, subscribeCurrentUser } from '@adornis/users/client/currentUser.js';
import { loginAfterValidation } from '@adornis/users/client/loginAfterValidation.js';
import { famedThemeDefinition, fsppThemeDefinition } from '@ils/theme/theme.js';
import '@ils/translation/translation.js';
import { brandDictionary } from '@ils/translation/translation.js';
import '@legacy-db/index.js';
import Tracker from '@openreplay/tracker';
import { html } from 'lit';
import { distinctUntilChanged } from 'rxjs/operators';
import { ILSUser } from '../db/ils-user.js';
import '../db/mails/index.js';
import { OnlineStatus } from '../db/online-status.js';
import './auto-examday-selection.js';
import './global-state.js';
import './main-element.js';

DesignSystem.setTheme('famed', famedThemeDefinition);
DesignSystem.setTheme('fspp', fsppThemeDefinition);
DesignSystem.useTheme('famed');

ExportDataView._translator.updateDictionary(brandDictionary);

registerServerLogger();
// replaceConsoleFunctions();
globalThis.logger = logger;

loginAfterValidation();

BaseQLClient.initDefault();

subscribeCurrentUser(() => ILSUser.allFields).catch(() => {});
OnlineStatus.ensureUserIsOnline()().catch(() => {});

registerTracking({ navigation: true });
if (baseConfig.get('DEPLOYMENT') === 'production') {
  const tracker = new Tracker({
    projectKey: 'LdSE2ojAYRBSwvSxnkaM',
    ingestPoint: 'https://openreplay.adornis.de/ingest',
    captureExceptions: true,
    obscureInputEmails: false,
    obscureInputNumbers: false,
    obscureInputDates: false,
    obscureTextNumbers: false,
    obscureTextEmails: false,
  });
  void tracker.start();

  currentUser<ILSUser>()
    .pipe(distinctUntilChanged())
    .subscribe(user => (user ? tracker.setUserID(user.email) : undefined));

  // add Google Adwords tags for conversion tracking
  const elem1 = document.createElement('script');
  elem1.src = 'https://www.googletagmanager.com/gtag/js?id=AW-716896371';
  document.body.appendChild(elem1);

  const elem2 = document.createElement('script');
  elem2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
    
      gtag('config', 'AW-716896371');
    `;
  document.body.appendChild(elem2);
}

void initApp(() => html` <main-element></main-element> `);
